document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".hgp-dharohar-card");

    if (!cards.length) return;

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("show");

            observer.unobserve(entry.target);

        });

    }, {

        threshold: 0.15

    });

    cards.forEach((card, index) => {

        card.style.transitionDelay = `${index * 90}ms`;

        observer.observe(card);

    });

});